export default {
  meta: {
    title: '企业详情'
  },
};
